import { useTranslation } from 'react-i18next';

const labels = {
  title: ['访问审计', 'Access audit'],
  rootOnly: ['仅限 Root 查看', 'Root access required'],
  organizations: ['组织', 'Organizations'],
  search: ['搜索', 'Search'],
  selectOrg: ['选择组织', 'Select organization'],
  owner: ['主账号', 'Owner'],
  member: ['成员', 'Member'],
  unknown: ['未知', 'Unknown'],
  loading: ['加载中', 'Loading'],
  retry: ['重试', 'Retry'],
  refresh: ['刷新', 'Refresh'],
  previous: ['上一页', 'Previous page'],
  next: ['下一页', 'Next page'],
  page: ['页', 'Page'],
  pageSize: ['每页', 'Page size'],
  emptyOrgs: ['没有匹配组织', 'No matching organizations'],
  policy: ['组织策略', 'Organization policy'],
  enabled: ['启用增强采集', 'Enable enhanced capture'],
  disabled: [
    '已停用采集；历史证据仍可查询和导出',
    'Capture disabled; retained evidence remains available',
  ],
  cidrs: [
    '预期 CIDR（逗号或换行分隔）',
    'Expected CIDRs (comma or newline separated)',
  ],
  countries: [
    '预期国家代码（逗号或换行分隔）',
    'Expected country codes (comma or newline separated)',
  ],
  note: ['备注', 'Note'],
  revision: ['策略版本', 'Policy revision'],
  save: ['保存策略', 'Save policy'],
  saved: ['已保存', 'Saved'],
  stale: [
    '策略已被修改；草稿保留。重新载入后再编辑保存。',
    'Policy changed elsewhere; draft retained. Reload before editing and saving.',
  ],
  reload: ['载入最新策略（替换草稿）', 'Reload latest policy (replace draft)'],
  unsaved: ['未保存', 'Unsaved'],
  unapplied: ['筛选未应用', 'Unapplied filters'],
  user: ['用户 ID', 'User ID'],
  token: ['密钥 ID', 'Key ID'],
  ip: ['来源 IP', 'Source IP'],
  country: ['国家代码', 'Country code'],
  app: ['客户端应用', 'Client application'],
  start: ['开始时间（本地时区）', 'Start time (local timezone)'],
  end: ['结束时间（本地时区）', 'End time (local timezone)'],
  timeZone: ['时间时区', 'Timezone'],
  apply: ['查询', 'Apply filters'],
  clear: ['清空筛选', 'Clear filters'],
  invalidID: [
    '用户和密钥 ID 必须为正整数',
    'User and key IDs must be positive integers',
  ],
  invalidTime: [
    '时间范围无效，开始时间须早于或等于结束时间',
    'Invalid time range; start must not follow end',
  ],
  events: ['事件', 'Events'],
  summary: ['特征分组', 'Feature groups'],
  all: ['全部', 'All'],
  login: ['登录', 'Login'],
  api: ['API 请求', 'API requests'],
  management: ['管理操作', 'Management'],
  eventType: ['事件类型', 'Event type'],
  eventTypeExact: ['精确事件类型', 'Exact event type'],
  time: ['发生时间', 'Occurred at'],
  identity: ['用户 / 密钥', 'User / key'],
  source: ['来源 / 位置', 'Source / location'],
  client: [
    '客户端特征（自报 / 推断）',
    'Client features (reported / inferred)',
  ],
  outcome: ['结果', 'Outcome'],
  incomplete: ['本记录无结束信息', 'No end information in this record'],
  unfinished: [
    '筛选内未匹配结束的开始记录',
    'Starts without a matching finish in selection',
  ],
  detail: ['详情', 'Details'],
  noEvents: ['没有匹配事件', 'No matching events'],
  noGroups: ['没有匹配特征分组', 'No matching feature groups'],
  total: ['证据记录总数', 'Total evidence records'],
  login_success: ['登录成功', 'Login success'],
  login_failure: ['登录失败', 'Login failure'],
  login_challenge: ['登录待验证', 'Login challenge'],
  api_start: ['API 开始', 'API start'],
  api_finish: ['API 结束', 'API finish'],
  policy_changed: ['策略变更', 'Policy changed'],
  root_review: ['Root 复核', 'Root review'],
  token_created: ['创建密钥', 'Key created'],
  token_updated: ['更新密钥', 'Key updated'],
  token_deleted: ['删除密钥', 'Key deleted'],
  session_created: ['创建会话', 'Session created'],
  session_revoked: ['撤销会话', 'Session revoked'],
  logout: ['退出登录', 'Logout'],
  outcomeUnknown: ['结果未知', 'Unknown outcome'],
  started: ['已开始', 'Started'],
  success: ['成功', 'Success'],
  failure: ['失败', 'Failure'],
  denied: ['被拒绝', 'Denied'],
  cancelled: ['已取消', 'Cancelled'],
  canceled: ['已取消', 'Cancelled'],
  pending: ['待完成', 'Pending'],
  ips: ['来源 IP 数', 'Distinct IPs'],
  clients: [
    '客户端特征组数（非设备数）',
    'Client feature groups (not device count)',
  ],
  countryCount: ['国家数', 'Countries'],
  unknownLocations: ['未知位置数', 'Unknown locations'],
  count: ['次数', 'Count'],
  seen: ['首次 / 最近出现', 'First / last seen'],
  signals: ['待复核线索', 'Signals for review'],
  observations: [
    '来源为观察、自报或 GeoIP 推断；不代表已验证设备、转售结论或封禁依据。',
    'Sources are observations, self-reports or GeoIP inferences, not verified devices, resale verdicts or blocking decisions.',
  ],
  partial: [
    '结果不完整；请缩小范围或导出证据，不能据此推算全部数量。',
    'Incomplete results; narrow filters or export evidence. Do not extrapolate totals.',
  ],
  summaryScope: ['汇总范围', 'Summary scope'],
  summaryLimit: [
    '汇总范围过大；请缩小时间范围。完整证据仍可导出。',
    'Summary range too large; narrow the period. Full export remains available.',
  ],
  reported: ['自报 / 推断', 'Reported / inferred'],
  inferred: ['GeoIP 推断', 'GeoIP inference'],
  geoStatus: ['位置状态', 'Location status'],
  trust: ['代理信任', 'Proxy trust'],
  configured: ['已配置', 'Configured'],
  notConfigured: ['未配置', 'Not configured'],
  failedWrites: ['采集写入失败数', 'Failed evidence writes'],
  pendingRetries: ['待重试', 'Pending retries'],
  unclassifiedSpool: ['未分类暂存文件', 'Unclassified spool files'],
  pendingWorker: ['Worker 待补写', 'Worker evidence backlog'],
  spool: ['证据暂存', 'Evidence spool'],
  available: ['可用', 'Available'],
  unavailable: ['不可用', 'Unavailable'],
  failureScope: ['失败计数范围', 'Failure counter scope'],
  current_process: ['本进程', 'Current process'],
  retention: ['保留策略', 'Retention'],
  no_automatic_deletion: ['无自动删除', 'No automatic deletion'],
  lastFailure: ['最近失败（原始时间）', 'Last failure (raw timestamp)'],
  collector: ['采集器', 'Collector'],
  status: ['采集状态', 'Collector status'],
  diagnostics: ['诊断数据', 'Diagnostics'],
  export: ['导出 JSONL', 'Export JSONL'],
  exported: [
    '已下载服务端证据包；完整性以包内清单和校验信息为准。',
    'Server evidence downloaded; use its manifest and checksums to verify completeness.',
  ],
  exportFailed: [
    '导出失败，未生成下载文件',
    'Export failed; no download created',
  ],
  error: ['请求失败', 'Request failed'],
  malformed: ['接口数据格式不符', 'Unexpected response format'],
  metadata: ['来源元数据', 'Source metadata'],
  geo: ['位置数据（推断）', 'Location data (inferred)'],
  chain: [
    '证据链（未在浏览器校验）',
    'Evidence chain (not verified in browser)',
  ],
  event: ['事件记录', 'Event record'],
  review: ['Root 复核备注', 'Root review note'],
  submitReview: ['追加复核', 'Append review'],
  reviewed: ['复核已追加', 'Review appended'],
  reviewQueued: ['复核已排队，待重试写入', 'Review queued for write retry'],
  reviewAccepted: [
    '复核已接收，可能待重试',
    'Review accepted; retry may be pending',
  ],
  reviewRequired: ['请输入复核备注', 'Enter a review note'],
  close: ['关闭', 'Close'],
  raw: ['原始数据', 'Raw data'],
  noPolicy: ['尚未载入有效策略', 'No valid policy loaded'],
};

export const auditLabel = (key, language = 'zh') =>
  labels[key]?.[language.startsWith('en') ? 1 : 0] || key;

export function useAuditLabels() {
  const { i18n } = useTranslation();
  const language = i18n?.resolvedLanguage || i18n?.language || 'zh';
  return (key) => auditLabel(key, language);
}
